import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Home_about_us from "./home_about_us/Home_about_us";
import Bill_payments from "./bill_payments/Bill_payments";
import Recharge from "./recharge/Recharge";
import Why_choose from "./why_choose_us/Why_choose";
import Download from "./download/Download";
import Vision from "./vision/Vision";
import What_our_users_say from "./what_our_users_say/What_our_users_say";
import Contribution from "./contribution/Contribution";
import Faq from "./faq/Faq";
import Explore_more_with_us from "./explore_more_with_us/Explore_more_with_us";
import Top_performance from "./top_performance/Top_performance";
import Referal_steps from "../refer_and_earn/referal_step/Referal_steps";


function Home({ animationData }) {
  const services = [
    {
      id: 1,
      img: "/assets/images/home/bill_payments/money.png",
      title: "Mobile Recharge",
      baseLink: "/mobile-recharge",
    },
    {
      id: 2,
      img: "/assets/images/home/bill_payments/satellite-dish.png",
      title: "DTH Recharge",
      baseLink: "/dth-recharge",
    },
    {
      id: 3,
      img: "/assets/images/home/bill_payments/light-bulb.png",
      title: "Electricity Bill",
      baseLink: "/electricity-recharge",
    },
    {
      id: 4,
      img: "/assets/images/home/bill_payments/gas-stove.png",
      title: "Gas Cylinder",
      baseLink: "/gas-recharge",
    },
    {
      id: 5,
      img: "/assets/images/home/bill_payments/buy-a-car.png",
      title: "FASTag Recharges",
      baseLink: "/fastag-recharge",
    },
  ];
  return (
    <>
      {/* <Banner />
      <Home_about_us />

      <Bill_payments
        services={services}
        sectionTitle="SEAMLESS BILL PAYMENTS & RECHARGES"
        sectionSubtitle="Recharge instantly, pay bills securely, and enjoy a hassle-free experience."
      />
      <Recharge />
      <Why_choose />
      <Download />
      <Vision />
      <What_our_users_say />
      <Contribution />
      <Faq /> */}


      <Banner />
      {/* <Top_performance /> */}
      <Home_about_us />

      <Bill_payments
        services={services}
        sectionTitle="SEAMLESS BILL PAYMENTS & RECHARGES"
        sectionSubtitle="Recharge instantly, pay bills securely, and enjoy a hassle-free experience."
      />
      <Recharge />
      <Why_choose />
      <Download />
      {/* <Explore_more_with_us /> */}
      <Vision />
      <Referal_steps />
      <What_our_users_say />
      <Contribution />
      <Faq />
    </>
  );
}

export default Home;
